import { MRT_ColumnDef } from "material-react-table";
import { useMemo, useState } from "react";
import SensorsIcon from '@mui/icons-material/Sensors';
import SensorsOffIcon from '@mui/icons-material/SensorsOff';
// import { useNavigate } from "react-router-dom";

// import { PermissionsEnum } from "@/auth/interfaces";
import {
  gridSizeMdLg12,
  hasPermission,
  ROUTER_PATHS,
  useLoaders,
  useTableServerSideFiltering,
  // hasAllPermissions,
  // useCheckPermissions,
} from "@/shared";
import { getRadiusRadReply, SingleRadiusObject, useFetchGetRadiusCheck, usePostActivacionesRadius } from "@/shared/actions/erp";
import {
  CustomSearch,
  GeneralTable,
  SingleIconButton,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import { useTableFilter } from "@/shared/hooks/useTableFilter";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { useUiConfirmModalStore } from "@/store/ui";
import { Info, Refresh } from "@mui/icons-material";
import { DetallesRadReplyModal } from "../../shared/components";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { PermissionsEnum } from "@/auth/interfaces";
// import { useUiConfirmModalStore } from "@/store/ui";
// import { SAVE_SERVICIO_CLIENTE_PERMISSIONS } from "../../shared/constants";

export type RadCheckPageMainProps = {};

const RadCheckPageMain: React.FC<RadCheckPageMainProps> = () => {
  // useCheckPermissions(PermissionsEnum.api_view_olt);

  const returnUrlRadCheckPageMain = ROUTER_PATHS.administration.radCheckNav;
  const [currentRad, setCurrentRad] = useState<SingleRadiusObject|null>(null);
  const [openModalDetailsRReply, setopenModalDetailsRReply] = useState(false);
  const queryClient = useQueryClient();
  // const navigate = useNavigate();
  ///* global state
  const setConfirmDialog = useUiConfirmModalStore((s) => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    (s) => s.setConfirmDialogIsOpen
  );

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter,
  } = useTableFilter();

  const { filterObject,
      columnFilters,
      setColumnFilters
  } = useTableServerSideFiltering();
  const { pageIndex, pageSize } = pagination;

  ///* fetch data
  const {
    data: RadCheckPagingRes,
    isLoading,
    isRefetching,
  } = useFetchGetRadiusCheck({
    params: {
      page: pageIndex + 1,
      page_size: Object.keys(filterObject).length > 0 ? 10000 : pageSize,
      username: searchTerm,
      ...filterObject,
    },
    enabled:true
  });
  const {
    mutateAsync: postActivacionesRadius,
    isPending: pendingActivacionesRadius,
  } = usePostActivacionesRadius({
    customSuccessMessage:"Registro actualizado correctamente",
    customMessageErrorAlert:"Error al actualizar el registro, por favor, intente nuevamente."
  })

  const radReply = async(username:string) => {
    const dataRadReply = await getRadiusRadReply({username:username})
    const dataDomainRadReply: SingleRadiusObject[] =  dataRadReply?.data
    return dataDomainRadReply?.find(item => item.attribute === 'Framed-IP-Address')?.value || null
  }

  ///* handlers

  // const onEdit = (radcheck: RadiusObjects) => {
  //   setConfirmDialog({
  //     isOpen: true,
  //     title: "Editar registro de RADIUS",
  //     subtitle: "¿Está seguro que desea actualizar este registro?",
  //     onConfirm: () => {
  //       setConfirmDialogIsOpen(false);
  //       navigate(`${returnUrlRadCheckPageMain}/actualizar/${radcheck.username}`);
  //     },
  //   });
  // };

  // const onDelete = (olt: OLT) => {
  //   setConfirmDialog({
  //     isOpen: true,
  //     title: "Eliminar OLT",
  //     subtitle: "¿Está seguro que desea eliminar este OLT?",
  //     onConfirm: () => {
  //       setConfirmDialogIsOpen(false);
  //       deleteOLT.mutate(olt.id_olt!);
  //     },
  //   });
  // };



  const columns = useMemo<MRT_ColumnDef<SingleRadiusObject>[]>(
    () => [
      {
        accessorKey: "identificacion",
        header: "Identificación",
        size: 160,
        Cell: ({ row }) => row.original?.cliente?.identificacion || "N/A",
      },
      {
        accessorKey: "razon_social",
        header: "Razon Social",
        size: 160,
        Cell: ({ row }) => row.original?.cliente?.razon_social || "N/A",
      },
      {
        accessorKey: "estado_navegacion",
        header: "Estado Navegación",
        size: 160,
        Cell: ({ row }) => row.original?.contrato?.estado_navegacion || "N/A",
      },
      {
        accessorKey: "username",
        header: "Username",
        size: 160,
        Cell: ({ row }) => row.original?.username || "N/A",
      },
      {
        enableColumnFilter: false,
        accessorKey: "value",
        header: "Value",
        size: 180,
        Cell: ({ row }) => row.original?.value || "N/A",
      },
      {
        enableColumnFilter: false,
        accessorKey: "attribute",
        header: "Attribute",
        size: 180,
        Cell: ({ row }) => row.original?.attribute || "N/A",
      },
      {
        enableColumnFilter: false,
        accessorKey: "id",
        header: "ID",
        size: 100,
        Cell: ({ row }) => row.original?.id ?? "N/A",
      },
      {
        enableColumnFilter: false,
        accessorKey: "op",
        header: "Operator",
        size: 120,
        Cell: ({ row }) => row.original?.op || "N/A",
      },
    ],
    []
  );
  //CUSTOM HOOKS

  // const { fileInputRef: importOLTs, handleImportarOLT } = useUploadFile();
  // const { fileInputRef: importTroncales, handleImportarTroncales } =
  //   useUploadFile();
  useLoaders(pendingActivacionesRadius)
  return (
    <SingleTableBoxScene
      title="RAD CHECK"
      urlRedirect={`${returnUrlRadCheckPageMain}/crear`}
      enableRedirect={
        hasPermission(PermissionsEnum.editar_datos_radius_cliente)
      }
    >
      <Grid {...gridSizeMdLg12} container spacing={2} justifyContent="flex-end">
        <SingleIconButton
          startIcon={<Refresh />}
          label="Refrescar"
          onClick={() => {
            queryClient.invalidateQueries({
              queryKey: ['rad-check'],
            });
          }}
        />
      </Grid>
      <CustomSearch
        onChange={onChangeFilter}
        value={globalFilter}
        text="por username"
        cleanFilter={cleanFilter}
      />

      <GeneralTable<SingleRadiusObject>
        columns={columns}
        data={RadCheckPagingRes?.data || []}
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableManualFiltering={true}
        enableColumnFilters={false}
        columnFilters={columnFilters}
        onColumnFiltersChange={setColumnFilters}
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={RadCheckPagingRes?.total}
        // // actions ========
        enableColumnActions={true}
        enableEditing={true}
        canEdit={false}
        showCustomActionBtnSpace={true}
        customActionBtnSpace={(val)=><>
          <Tooltip title={"Activar"}>
            <IconButton 
            disabled={pendingActivacionesRadius}
            onClick={()=>{
              setConfirmDialog({
                isOpen: true,
                subtitle: "¿Está seguro que desea reactivar el registro seleccionado?",
                title: "Reactivar Registro",
                onConfirm: async() => {
                  const ip = await radReply(val.username!)
                  setConfirmDialogIsOpen(false);
                  if(!ip){
                    return toast.error("No se encontro la ip del cliente")
                  }
                  postActivacionesRadius({
                    type_request:"REACTIVATE",
                    pppoe:val.username!,
                    ipv4:ip,
                  })
                },
                onClose() {
                  setConfirmDialogIsOpen(false);
                },
              });
            }}
            size={"large"}>
              <SensorsIcon/>
            </IconButton>
          </Tooltip>
          <Tooltip title={"Suspender"}>
            <IconButton 
            disabled={pendingActivacionesRadius}
            onClick={()=>{
              setConfirmDialog({
                isOpen: true,
                subtitle: "¿Está seguro que desea suspender el registro seleccionado?",
                title: "Suspender Registro",
                onConfirm: () => {
                  if(!val.username){
                    return toast.error("No se encontro el username del cliente")
                  }
                  postActivacionesRadius({
                    type_request:"STOP",
                    pppoe:val.username!
                  })
                  setConfirmDialogIsOpen(false);
                },
                onClose() {
                  setConfirmDialogIsOpen(false);
                },
              });
            }}
            size={"large"}>
              <SensorsOffIcon/>
            </IconButton>
          </Tooltip>
          <Tooltip title={"Detalles"}>
            <IconButton 
            onClick={()=>{
              setCurrentRad(val)
              setopenModalDetailsRReply(true)
            }}
            size={"large"}>
              <Info/>
            </IconButton>
          </Tooltip>
        </>}
        // actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
        // crud
        // onEdit={onEdit}
        // canDelete={false}
        // onDelete={onDelete}
      />
      <DetallesRadReplyModal
        open={openModalDetailsRReply}
        onClose={()=>{
          setopenModalDetailsRReply(false)
        }}
        username={currentRad?.username||""}
        password={currentRad?.value||""}
      />
    </SingleTableBoxScene>
  );
};

export default RadCheckPageMain;
